export enum ECommonActions {
  CleanStore = 'CLEAN_STORE',
}

export interface ICleanStoreAction {
  type: ECommonActions.CleanStore,
}
